module.exports = ":host ::ng-deep .form-group {\n  margin-bottom: 0;\n}\n:host ::ng-deep .fixed-width {\n  min-width: 180px;\n}"